import "./SegmentButton.css";

export default function SegmentButton({ segments, onSegmentChange, chosen, badgeIndex }) {
  return (
    <div className="segmentButtonWrapper">
      {segments &&
        segments?.map((item, i) => {
          return (
            <div
              className={chosen !== i ? "segmentButton" : "segmentButtonOption"}
              key={i}
              onClick={() => onSegmentChange(i)}
            >
              <span
                className={
                  chosen !== i ? "segmentButtonTxt" : "segmentButtonTxtOption"
                }
              >
                {item}
                {badgeIndex === i && <span className="segmentButtonBadge" aria-label="Есть новые элементы" />}
              </span>
            </div>
          );
        })}
    </div>
  );
}
